import { useTranslation as useI18nTranslation } from 'react-i18next';

export interface TranslationOptions {
  [key: string]: string | number | boolean;
}

export interface UseTranslationReturn {
  t: (key: string, options?: TranslationOptions) => string;
  i18n: any;
  ready: boolean;
  changeLanguage: (language: string) => Promise<void>;
  currentLanguage: string;
}

/**
 * Custom hook for translations with enhanced functionality
 * Provides easy access to translation functions and language management
 */
export const useTranslation = (namespace?: string): UseTranslationReturn => {
  const { t, i18n, ready } = useI18nTranslation(namespace);

  const changeLanguage = async (language: string): Promise<void> => {
    await i18n.changeLanguage(language);
  };

  return {
    t,
    i18n,
    ready,
    changeLanguage,
    currentLanguage: i18n.language,
  };
};

/**
 * Hook for common translations
 */
export const useCommonTranslation = () => useTranslation('common');

/**
 * Hook for navigation translations
 */
export const useNavigationTranslation = () => useTranslation('navigation');

/**
 * Hook for tutorial translations
 */
export const useTutorialTranslation = () => useTranslation('tutorials');

/**
 * Hook for product translations
 */
export const useProductTranslation = () => useTranslation('products');

/**
 * Hook for authentication translations
 */
export const useAuthTranslation = () => useTranslation('auth');

export default useTranslation;
